import { useEffect, useState } from 'react'
import './style.css'
import Multiselect from 'multiselect-react-dropdown'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSearch, updateJobPreference } from '../../../Redux/Actions/ProfileSteps'
import moment from 'moment'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import { RESET_SEARCH } from '../../../Redux/Actions/types'
const JobPreference = ({ setCurrentStep }) => {
  const dispatch = useDispatch()

  const kids = useSelector((state) => state.dashboard.kids)
  const preferredSearch = useSelector((s) => s.ProfileSteps.searchByField.preferred_location)
  const interestSearchResults = useSelector((s) => s.ProfileSteps.searchByField.area_of_interest)
  const profileData = useSelector((s) => s.ProfileSteps.profileData)
  const [isChanged, setIsChanged] = useState({})
  const [prefillData, setPrefillData] = useState({})
  const [formData, setFormData] = useState({})

  const [locationSearch, setLocationSearch] = useState('')
  const [interestSearch, setInterestSearch] = useState('')
  const [debouncedLocationSearch, setDebouncedLocationSearch] = useState('')
  const [debouncedInterestSearch, setDebouncedInterestSearch] = useState('')

  const [locationResults, setLocationResults] = useState([])
  const [interestResults, setInterestResults] = useState([])

  useEffect(() => setLocationResults(preferredSearch || []), [preferredSearch])
  useEffect(() => setInterestResults(interestSearchResults || []), [interestSearchResults])
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [])
  useEffect(() => {
    setPrefillData({
      ...profileData,
      preferred_job_location:
        typeof profileData.preferred_job_location === 'string'
          ? profileData.preferred_job_location
              .split(', ')
              .map((s) => s.trim())
              .filter(Boolean)
          : Array.isArray(profileData.preferred_job_location)
            ? profileData.preferred_job_location
            : [],

      area_of_interest:
        profileData.area_of_interest_1 || profileData.area_of_interest_2 || profileData.area_of_interest_3
          ? [profileData.area_of_interest_1, profileData.area_of_interest_2, profileData.area_of_interest_3].filter(Boolean).filter((v) => v !== '0')
          : [],
    })
    setFormData((prev) => {
      const next = { ...prev }
      // const byName = new Map(interestResults.map((o) => [o.object_name, o]));

      for (let i = 1; i <= 3; i++) {
        const prefillValue = profileData[`area_of_interest_${i}`]
        if (prefillValue && prefillValue !== null) {
          next[`area_of_interest_${i}`] = prefillValue
          // const obj = byName.get(prefillValue);
          // if (obj) {
          //   next[`area_interest_${i}`] = String(obj.object_id);
          // }
        }
      }

      return next
    })
  }, [profileData])
  useEffect(() => {
    const t = setTimeout(() => setDebouncedLocationSearch(locationSearch), 500)
    return () => clearTimeout(t)
  }, [locationSearch])

  useEffect(() => {
    const t = setTimeout(() => setDebouncedInterestSearch(interestSearch), 500)
    return () => clearTimeout(t)
  }, [interestSearch])

  useEffect(() => {
    const run = async () => {
      if ((debouncedLocationSearch || '').trim().length >= 3) {
        try {
          await dispatch(
            fetchSearch({
              search_type: 'locationsOpenTo',
              search_char: debouncedLocationSearch,
              context: 'preferred_location',
            }),
          )
        } catch (err) {
          console.error('Preferred location search failed:', err)
          setLocationResults([])
        }
      } else {
        setLocationResults([])
      }
    }
    run()
  }, [debouncedLocationSearch, dispatch])

  useEffect(() => {
    const run = async () => {
      if ((debouncedInterestSearch || '').trim().length >= 3) {
        try {
          await dispatch(
            fetchSearch({
              search_type: 'areaOfInterest',
              search_char: debouncedInterestSearch,
              context: 'area_of_interest',
            }),
          )
        } catch (err) {
          console.error('Area of interest search failed:', err)
          setInterestResults([])
        }
      } else {
        setInterestResults([])
      }
    }
    run()
  }, [debouncedInterestSearch, dispatch])

  const handleDobChange = (date) => {
    if (!date) {
      setFormData((prev) => ({ ...prev, available_tojoin_from: '' }))
      return
    }

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`

    setFormData((prev) => ({ ...prev, available_tojoin_from: formattedDate }))
  }

  const toggleBool = (key) => {
    setFormData((prev) => ({ ...prev, [key]: !prev[key] }))
    setIsChanged((prev) => ({ ...prev, [key]: true }))
  }

  const handleLocationSelect = (selectedList) => {
    setFormData((prev) => ({ ...prev, preferred_job_location: selectedList }))
    setIsChanged((prev) => ({ ...prev, preferred_job_location: true }))
  }

  const handleLocationRemove = (selectedList) => {
    setFormData((prev) => ({ ...prev, preferred_job_location: selectedList }))
    setIsChanged((prev) => ({ ...prev, preferred_job_location: true }))
  }

  const handleInterestSelect = (selectedList) => {
    const top3 = selectedList.slice(0, 3)
    const currentItem = top3[top3.length - 1]
    const byName = new Map((interestResults || []).map((o) => [o.object_name, o]))
    const picked = currentItem ? byName.get(currentItem) : null
    setFormData((prev) => {
      const next = { ...prev }

      if (picked) {
        for (let i = 1; i <= 3; i++) {
          const isEmpty = !next[`area_of_interest_${i}`] || next[`area_of_interest_${i}`] === '0' || next[`area_of_interest_${i}`] === ''

          if (isEmpty) {
            next[`area_interest_${i}`] = String(picked.object_id)
            next[`area_of_interest_${i}`] = picked.object_name
            break
          }
        }
      }

      return next
    })
  }
  const handleInterestRemove = (selectionList, removedItem) => {
    setFormData((prev) => {
      const next = { ...prev }

      for (let i = 1; i <= 3; i++) {
        if (next[`area_of_interest_${i}`] === removedItem) {
          next[`area_interest_${i}`] = '0'
          next[`area_of_interest_${i}`] = '0'
          break
        }
      }

      return next
    })
  }

  const handleSaveAndNext = async () => {
    const hasData = formData && Object.keys(formData).length > 0

    if (hasData) {
      const updatedFormData = {
        ...formData,
        kid_id: kids?.[0]?.id,
        preferred_job_location: Array.isArray(formData.preferred_job_location)
          ? formData.preferred_job_location
              .map((s) => (typeof s === 'string' ? s.trim() : String(s)))
              .filter(Boolean)
              .join(', ')
          : formData.preferred_job_location,
      }
      await dispatch(updateJobPreference(updatedFormData))
    } else {
    }

    setCurrentStep(4)
  }
  const initialFetch = async (type, context) => {
    try {
      await dispatch({ type: RESET_SEARCH })
      await dispatch(
        fetchSearch({
          search_type: type,
          search_char: 'prominentdef',
          context: context,
        }),
      )
    } catch (err) {
      console.error(' search failed:', err)
    }
  }
  return (
    <>
      <div className="container-fluid">
        <div className="col-md-8 offset-md-2 py-5">
          <div className="form-bg">
            <div className="form-group">
              <label className="mb-2">Type of Role</label>
              <div className="custom-radio-main inter">
                <label className="checkbox-container form-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isChanged?.intern_twomon_search ? !!formData.intern_twomon_search : profileData?.intern_twomon_search}
                    onChange={() => toggleBool('intern_twomon_search')}
                  />
                  <span className="checkboxmark form-check-label">Internship 2 months</span>
                </label>

                <label className="checkbox-container form-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isChanged?.intern_sixmon_search ? !!formData.intern_sixmon_search : profileData?.intern_sixmon_search}
                    onChange={() => toggleBool('intern_sixmon_search')}
                  />
                  <span className="checkboxmark form-check-label">Internship 6 months</span>
                </label>

                <label className="checkbox-container form-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isChanged?.full_time_search ? !!formData.full_time_search : profileData?.full_time_search}
                    onChange={() => toggleBool('full_time_search')}
                  />
                  <span className="checkboxmark form-check-label">Full Time</span>
                </label>
              </div>
            </div>

            <div className="form-group">
              <label className="mb-2">Job Type</label>
              <div className="custom-radio-main inter">
                <label className="checkbox-container form-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isChanged?.job_type_wfo ? !!formData.job_type_wfo : profileData?.job_type_wfo}
                    onChange={() => toggleBool('job_type_wfo')}
                  />
                  <span className="checkboxmark form-check-label">Work from Office</span>
                </label>

                <label className="checkbox-container form-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isChanged?.job_type_wfh ? !!formData.job_type_wfh : profileData?.job_type_wfh}
                    onChange={() => toggleBool('job_type_wfh')}
                  />
                  <span className="checkboxmark form-check-label">Work from home</span>
                </label>

                <label className="checkbox-container form-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isChanged?.job_type_hybrid ? !!formData.job_type_hybrid : profileData?.job_type_hybrid}
                    onChange={() => toggleBool('job_type_hybrid')}
                  />
                  <span className="checkboxmark form-check-label">Hybrid</span>
                </label>
              </div>
            </div>

            <div className="form-group">
              <label className="mb-2">Available to join from</label>
              <DatePicker
                className="form-control"
                name="available_tojoin_from"
                onChange={handleDobChange}
                value={
                  (formData?.available_tojoin_from && moment(formData?.available_tojoin_from).format('YYYY-MM-DD')) ||
                  (profileData?.available_tojoin_from && moment(profileData?.available_tojoin_from).format('YYYY-MM-DD'))
                }
                defaultValue={new Date()}
                // maxDate={new Date()}
                format="dd/MM/y"
                dayPlaceholder="dd"
                monthPlaceholder="mm"
                yearPlaceholder="yyyy"
              />
            </div>

            <div className="form-group placholder">
              <label className="mb-2">Preferred job location</label>
              <div onFocus={() => initialFetch('locationsOpenTo', 'preferred_location')}>
                <Multiselect
                  style={{ inputField: {backgroundColor : '#ffffff'}}}
                  id="preferred_location"
                  isObject={false}
                  onRemove={handleLocationRemove}
                  onSelect={handleLocationSelect}
                  onSearch={setLocationSearch}
                  placeholder="Type 3+ characters to search"
                  options={(locationResults || []).map((item) => item.object_name)}
                  selectedValues={formData.preferred_job_location || prefillData.preferred_job_location || []}
                />
              </div>
            </div>

            <div className="form-group placholder">
              <label className="mb-2">Area of Interest (select upto 3)</label>
              <div onFocus={() => initialFetch('areaOfInterest', 'area_of_interest')}>
                <Multiselect
                  style={{ inputField: {backgroundColor : '#ffffff'}}}
                  id="area_of_interest"
                  isObject={false}
                  selectionLimit={3}
                  onRemove={handleInterestRemove}
                  onSelect={handleInterestSelect}
                  onSearch={setInterestSearch}
                  placeholder="Type 3+ characters to search"
                  options={(interestResults || []).map((item) => item.object_name)}
                  selectedValues={formData.area_of_interest || prefillData.area_of_interest || []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="btn-footer">
        <div className="container-fluid d-flex justify-content-lg-end">
          <button className="default-btn default-border bg-transparent back-btn me-3" onClick={() => setCurrentStep(2)}>
            <img src="./images/back-arrow.png" className="d-block d-md-none" />
            <span className="d-none d-md-block">Back</span>
          </button>
          <button className="default-btn default-border bg-transparent me-3" onClick={() => setCurrentStep(4)}>
            Skip
          </button>
          <button className="default-btn" onClick={handleSaveAndNext}>
            Save & Next
          </button>
        </div>
      </div>
    </>
  )
}

export default JobPreference
